export interface EntityModalPermiss {
    show: boolean;
    step: 'required' | 'type-permiss';
    options: number[];
}

export const initEntityModalPermiss: EntityModalPermiss = {
    show: false,
    step: 'required',
    options: [1]
}